import { Quote, Star } from "lucide-react";

const testimonials = [
  {
    name: "Maria D.",
    location: "Bethesda, MD",
    text: "B&J installed our EV charger and upgraded our panel in one day. Clean, professional, on-time. Best electricians we've worked with.",
    rating: 5,
  },
  {
    name: "James P.",
    location: "Arlington, VA",
    text: "Finished basement lighting looks incredible. Fair pricing and they walked me through every step. Highly recommend.",
    rating: 5,
  },
  {
    name: "Angela R.",
    location: "Silver Spring, MD",
    text: "Called for a wiring emergency at 8pm. They were at my house within an hour. Lifesavers.",
    rating: 5,
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="relative py-24 lg:py-32 bg-[#080809] border-y border-white/5">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-3xl mb-14">
          <div className="text-xs uppercase tracking-[0.28em] text-yellow-400 font-bold mb-4">
            Real Reviews
          </div>
          <h2 className="font-display font-black text-white text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95]">
            Homeowners across<br />the DMV, <span className="text-yellow-400">love us</span>.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {testimonials.map((t, i) => (
            <article
              key={t.name}
              data-testid={`testimonial-${i}`}
              className="relative bg-[#0d0d0f] border border-white/10 rounded-xl p-7 hover:border-yellow-400/40 hover:-translate-y-1 transition-all duration-300"
            >
              <Quote className="w-8 h-8 text-yellow-400/30 mb-4" strokeWidth={1.5} />
              <div className="flex gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, k) => (
                  <Star key={k} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                ))}
              </div>
              <p className="text-white/80 leading-relaxed mb-6">"{t.text}"</p>
              <div className="pt-4 border-t border-white/10">
                <div className="text-white font-semibold">{t.name}</div>
                <div className="text-white/50 text-xs uppercase tracking-[0.15em] mt-1">{t.location}</div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
